import { Typography, Stack, Card } from '@mui/material';
import { t } from 'i18next'
import BillingQuotesItemsTable from "./BillingQuotesItemsTable";

type BillingQuotesProps = {
    deals: any
}

function BillingQuotes({ deals }: BillingQuotesProps) {

    return (
        <Card sx={{ p: 3 }}>
            {deals != null && (
                <div className="fixed-width">
                    <Stack spacing={2}>
                        <Typography variant="h5" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                            {t("billing:quotes")}
                        </Typography>
                        <BillingQuotesItemsTable deals={deals}></BillingQuotesItemsTable>
                    </Stack>
                </div>
            )
            }
        </Card>
    );
}

export default BillingQuotes;
